/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { Ladder } from './Ladder';
import {
    LadderFromJSON,
    LadderFromJSONTyped,
    LadderToJSON,
    LadderToJSONTyped,
} from './Ladder';

/**
 * 
 * @export
 * @interface GetLaddersResponse
 */
export interface GetLaddersResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetLaddersResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<Ladder>}
     * @memberof GetLaddersResponse
     */
    ladders: Array<Ladder>;
}

/**
 * Check if a given object implements the GetLaddersResponse interface.
 */
export function instanceOfGetLaddersResponse(value: object): value is GetLaddersResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('ladders' in value) || value['ladders'] === undefined) return false;
    return true;
}

export function GetLaddersResponseFromJSON(json: any): GetLaddersResponse {
    return GetLaddersResponseFromJSONTyped(json, false);
}

export function GetLaddersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLaddersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'ladders': ((json['ladders'] as Array<any>).map(LadderFromJSON)),
    };
}

export function GetLaddersResponseToJSON(json: any): GetLaddersResponse {
    return GetLaddersResponseToJSONTyped(json, false);
}

export function GetLaddersResponseToJSONTyped(value?: GetLaddersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'ladders': ((value['ladders'] as Array<any>).map(LadderToJSON)),
    };
}

